export default "__VITE_ASSET__OxnezmxQ__"